import createIcon from '../../createIcon';

/**
 * @component @name Wallet
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNEg2QzMuNzkgNCAyIDUuNzkgMiA4VjE2QzIgMTguMjEgMy43OSAyMCA2IDIwSDE4QzIwLjIxIDIwIDIyIDE4LjIxIDIyIDE2VjhDMjIgNS43OSAyMC4yMSA0IDE4IDRaTTE2LjE0IDEzLjc3QzE1LjkgMTMuOTcgMTUuNTcgMTQuMDUgMTUuMjYgMTMuOTdMNC4xNSAxMS4yNUM0LjQ1IDEwLjUyIDUuMTYgMTAgNiAxMEgxOEMxOC42NyAxMCAxOS4yNiAxMC4zNCAxOS42MyAxMC44NEwxNi4xNCAxMy43N1pNNiA2SDE4QzE5LjEgNiAyMCA2LjkgMjAgOFY4LjU1QzE5LjQxIDguMjEgMTguNzMgOCAxOCA4SDZDNS4yNyA4IDQuNTkgOC4yMSA0IDguNTVWOEM0IDYuOSA0LjkgNiA2IDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Wallet = createIcon('Wallet', [
  [
    'path',
    {
      d: 'M18 4H6C3.79 4 2 5.79 2 8V16C2 18.21 3.79 20 6 20H18C20.21 20 22 18.21 22 16V8C22 5.79 20.21 4 18 4ZM16.14 13.77C15.9 13.97 15.57 14.05 15.26 13.97L4.15 11.25C4.45 10.52 5.16 10 6 10H18C18.67 10 19.26 10.34 19.63 10.84L16.14 13.77ZM6 6H18C19.1 6 20 6.9 20 8V8.55C19.41 8.21 18.73 8 18 8H6C5.27 8 4.59 8.21 4 8.55V8C4 6.9 4.9 6 6 6Z',
      key: '1gtqts',
    },
  ],
]);

export default Wallet;
